<template>
  <div class="view pa24" :key="i18nUpdateKey">
    <el-form :model="ruleForm" label-width="auto">
      <el-form-item :label="sectionLabel">
        <el-upload :action="uploadUrl" :class="{ disabled: uploadDisabled }" list-type="picture-card"
          :on-progress="handProgress" :on-success="handleSuccess" :on-preview="handlePictureCardPreview"
          :on-remove="handleRemove" :on-error="handleError" :file-list="ruleForm.fileList" :limit="6">
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">
            {{ $t('business', 'uploadTip') }}
          </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false" :destroy-on-close="true">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveForm('0')">{{ $t('business', 'save') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  insertCompanyPhoto,
  selectCompanyPhoto
} from "@/api/client";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  data() {
    return {
      ruleForm: {
        fileList: [],
      },
      dialogVisible: false,
      dialogImageUrl: '',
      uploadUrl: this.$store.state.uploadingUrl,
      ossUrl: this.$store.state.ossUrl,
      type: 1,
      isLoading: false,
    };
  },
  computed: {
    uploadDisabled() {
      return this.ruleForm.fileList.length >= 6;
    },
    sectionLabel() {
      if (this.type == 1) {
        return this.$t('business', 'mallSection');
      } else if (this.type == 2) {
        return this.$t('business', 'appointmentSection');
      } else {
        return this.$t('business', 'dynamicSection');
      }
    }
  },
  created() {
    this.$set(this, 'type', this.$route.query.type)
    this.getCompanyPhoto()
  },
  mounted() {
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    handleRemove(file, fileList) {
      this.ruleForm.fileList = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handProgress(event, file, fileList) {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      this.$message({
        message: this.$t('business', 'uploading'),
      });
    },
    handleSuccess(response, file, fileList) {
      this.$message.closeAll();
      this.isLoading = false
      this.$message({
        message: this.$t('business', 'uploadSuccess'),
        type: "success",
      });
      this.ruleForm.fileList = fileList;
    },
    handleError(err, file, fileList) {
      this.isLoading = false;
      this.$message({
        message: this.$t('business', 'uploadFailed'),
        type: "error",
      });
    },
    saveForm() {
      let photos = this.ruleForm.fileList.map((item) =>
        item.response.data.indexOf("https") >= 0
          ? item.response.data
          : this.ossUrl + item.response.data + '.primary.png'
      )
      let data = {
        type: this.type,
        photoList: photos
      }
      insertCompanyPhoto(data)
        .then(res => {
          if (res.code == 200) {
            this.$message({
              message: this.$t('business', 'settingSuccess'),
              type: "success",
            });
            this.$router.go(-1)
          }
        })
    },
    getCompanyPhoto() {
      let data = {
        type: this.type,
      }
      selectCompanyPhoto(data)
        .then(res => {
          let img = res.data.map(val => val.photo) || [];
          this.ruleForm = {
            fileList: img.map((item) => ({
              url: item,
              response: {
                data: item,
              },
            }))
          }
        }).catch(err => {
          this.ruleForm.fileList = [];
          console.log('Failed to load company photos:', err);
        })
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .disabled .el-upload--picture-card {
  display: none;
}
</style>